module.exports = __webpack_public_path__ + "img/social-networks.7d26dbff.svg";